// extracted by mini-css-extract-plugin
module.exports = {"image":"CoachDetail_image__3Ormw","name":"CoachDetail_name__b4iCy","title":"CoachDetail_title__32Z4a","fadeIn":"CoachDetail_fadeIn__1lJW-"};